import { render, staticRenderFns } from "./firmCollect.vue?vue&type=template&id=10454d1e&scoped=true&"
import script from "./firmCollect.vue?vue&type=script&lang=js&"
export * from "./firmCollect.vue?vue&type=script&lang=js&"
import style0 from "./firmCollect.vue?vue&type=style&index=0&id=10454d1e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10454d1e",
  null
  
)

export default component.exports